export const API_URL:string = process.env.REACT_APP_API_URL as string;
export const API_KEY:string = process.env.REACT_APP_API_KEY as string;
export const STRIPE_CLIENT_ID:string = process.env.REACT_APP_STRIPE_CLIENT_ID as string;
export const MY_CC_URL:string = process.env.REACT_APP_MY_CC_URL as string;
export const GOOGLE_PLACES_API_KEY:string = process.env.REACT_APP_GOOGLE_PLACES_API_KEY as string;
export const ENVIRONMENT_NAME:string = process.env.REACT_APP_ENVIRONMENT_NAME || "local" as string;
export const SENTRY_DSN:string = process.env.REACT_APP_SENTRY_DSN as string;
export const BASE_URL = process.env.REACT_APP_BASE_URL || '';
export const GTM_ID = process.env.REACT_APP_GTM_ID || '';
export const GTM_PREVIEW = process.env.REACT_APP_GTM_PREVIEW;
export const GTM_AUTH = process.env.REACT_APP_GTM_AUTH;